export default "__VITE_ASSET__BV9SHuE2__"